module.exports = __webpack_public_path__ + "static/aire-acondicionado-ce26dfd955d60a0827e77a72e4d6cc79.jpg";